import React, { useCallback } from 'react'
import { createContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getLightboxFilesForSelectedTopic } from 'reduxes/slices/topics/selectors'

import { Lightbox } from './lightbox'
import { FileData, LightboxContextType } from './types'

export const LightboxContext = createContext<LightboxContextType>(undefined)

export const LightboxProvider: React.FC = ({ children }) => {
  const [data, setData] = useState<FileData | undefined>(undefined)
  const files: FileData[] = useSelector(getLightboxFilesForSelectedTopic)

  const [invalidate, setInvalidate] = useState<boolean>(false)

  useEffect(() => {
    const launchLightbox = (e: any) => {
      const lightboxFileUrl = e.currentTarget.getAttribute('data-fileurl')
      if (!lightboxFileUrl) {
        return
      }

      // Prevent event from tunneling - this is primarily for video elements
      e.preventDefault()

      const fileData = files.find(
        (file) => file.url === lightboxFileUrl,
      ) as FileData
      setData(fileData)
    }

    const lightBoxTriggers = document.querySelectorAll('[data-lightbox="true"]')
    lightBoxTriggers.forEach((trigger) => {
      trigger.addEventListener('click', launchLightbox, true)
    })

    return () => {
      lightBoxTriggers.forEach((trigger) => {
        trigger.removeEventListener('click', launchLightbox, true)
      })
    }
  }, [files, invalidate])

  const onInvalidate = useCallback(() => {
    setInvalidate((i) => !i)
  }, [])

  return (
    <>
      <LightboxContext.Provider value={onInvalidate}>
        {children}
      </LightboxContext.Provider>
      {data && <Lightbox data={data} setData={setData} />}
    </>
  )
}
